import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Colors, FindLoad, FindSuccessItem, Images, useGlobalTextStyles, useModal } from 'utils';
import { claimActions, httpRequestsOnSuccessActions } from 'store';
import { modalsStyle } from '../../../../components/modal/styles';
import { MinLoader } from 'components';

const MARK_ACTION_TYPE = 'MARK_AS_SECONDARY_BILLING';
export const ManageSecondaryBilling = ({ claim, afterSuccess }) => {
    const classes = modalsStyle();
    const globalText = useGlobalTextStyles();
    const loader = FindLoad(MARK_ACTION_TYPE);
    const success = FindSuccessItem(MARK_ACTION_TYPE);
    const dispatch = useDispatch();
    const { close } = useModal();
    const [action, setAction] = useState('');

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(MARK_ACTION_TYPE));
            close();
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    const handleCloseModal = () => {
        close();
    };

    const handleAction = (name) => {
        setAction(name);
        const params = {};

        if (name === 'unmark') {
            params.mark = false;
        }
        if (name === 'submit') {
            params.markSubmitted = true;
        }

        dispatch(claimActions.markAsSecondaryBilling(claim?.id, { ...params }));
    };

    return (
        <div className={classes.customDeleteModal} style={{ width: 565 }}>
            <div>
                <p className={globalText.modalTitle}>Manage Secondary Billing</p>
                <p className={globalText.modalText}>Are you sure you want to unmark or submit this claim?</p>
                <div>
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start', marginBottom: 12 }}>
                        <img style={{ marginTop: '3px' }} src={Images.receipt} alt="icon" />
                        <p style={{ fontWeight: 400, color: '#0C66E4' }}>{claim?.displayId}</p>
                    </div>
                </div>

                <div className={classes.buttons}>
                    <button className="close-btn-box" onClick={handleCloseModal}>
                        Cancel
                    </button>
                    <button disabled={loader?.length} className="confirm-btn-light" onClick={() => handleAction('unmark')}>
                        {loader?.length && action === 'unmark' ? <MinLoader margin={'0'} color={Colors.ThemeBlue} /> : <>Unmark Claim</>}
                    </button>
                    <button disabled={loader?.length} className="confirm-btn" onClick={() => handleAction('submit')}>
                        {loader?.length && action === 'submit' ? (
                            <MinLoader margin={'0'} color={Colors.TextWhite} />
                        ) : (
                            <>Mark as Submitted</>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
